import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseAppSyncService } from 'src/app/services/base-app-sync.service';
import { getAORs } from '../../graphql/facilities/get-aors';
import { AorBuilderService } from '../builder/aor-builder.service';
import { AOR } from '../../model/locations/aor';

@Injectable({
  providedIn: 'root',
})
export class AorApiService extends BaseAppSyncService {
  private _aorBuilderService = inject(AorBuilderService);

  getAORs(businessUnits: string[] | null): Observable<AOR[]> {
    return this.query(
      getAORs,
      { businessUnits },
      (items: any[]) => items.map((i) => this._aorBuilderService.buildAor(i)),
      'getAORs',
      'cache-first'
    );
  }
}
